import { IApi, useClientApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import { useUser } from '@clerk/nextjs'
import type { IOrganizationsData } from 'api/dist/routes/users/organizations'

export type IOrganization = IOrganizationsData[number]

export class OrganizationsQuery {
    static getKey() {
        return ['organizations', 'get-organizations']
    }

    static async call(queryClient: IApi) {
        return queryClient.get<IOrganizationsData>('/users/organizations/').then((res) => res?.data)
    }
}

export function useOrganizationsQuery() {
    const api = useClientApi()
    const currentUser = useUser()

    return useApiQuery({
        queryKey: OrganizationsQuery.getKey(),
        queryFn: () => OrganizationsQuery.call(api),
        enabled: !!currentUser && currentUser?.isLoaded,
    })
}
